import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'seagull';
import cn from 'classnames';
import { useShallowStore, useStoreActions } from "../../../contexts";
import { StepPage } from "../../components/StepPage";
import { AgreementHeader } from "../../components/AgreementHeader";
import { useResponsive } from "../../contexts";
import { NEW_BUSINESS_NAME_FLAG, useWelcomeStepUtils } from "./welcomeStepUtils";
import { TextBox } from "../../components/TextBox";
import { useCobStorage } from "../CobStorageContext";
import styles from "./WelcomeStep.module.scss";
import { selectors } from "../../../store/state-selectors";
import { Intent } from "../../../infra/access-control";
import { replacePlaceholders } from "../../../utils/introductory-message.utils";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
export default function WelcomeStep(_ref) {
  var _selectedWorkspace$na, _relationship$buyer$f;

  let {
    onDone,
    refresh
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    getFromStorage
  } = useCobStorage(relationship);
  const {
    createOrSelectBusiness,
    newBusinessWorkspace
  } = useWelcomeStepUtils({
    relationship
  });
  const [worksAt, workspaces] = useShallowStore(state => [selectors.user.business(state), selectors.user.workspaces(state)]);
  const {
    logBI
  } = useStoreActions();
  const nextButtonProps = relationship.serviceBundles ? {
    text: 'Select a Package',
    intent: Intent.SelectPackage
  } : {
    text: relationship.isSample ? 'Review test agreement' : 'Review the agreement',
    intent: Intent.ReviewAgreement
  };

  const getSelectedWorkspace = () => {
    const shouldUseRelationshipCustomer = relationship.isSample || isPreview;
    const isNewBusinessSelected = relationship.suggestedCustomerName && !(newBusinessWorkspace !== null && newBusinessWorkspace !== void 0 && newBusinessWorkspace.id) && getFromStorage('select_new_business') !== false;
    const newBusiness = {
      id: NEW_BUSINESS_NAME_FLAG,
      name: relationship.suggestedCustomerName
    };
    return shouldUseRelationshipCustomer ? relationship.customer : isNewBusinessSelected ? newBusiness : worksAt || (workspaces === null || workspaces === void 0 ? void 0 : workspaces[0]);
  };

  const [selectedWorkspace, setSelectedWorkspace] = useState(getSelectedWorkspace());
  useEffect(() => {
    setSelectedWorkspace(getSelectedWorkspace());
  }, [worksAt, relationship]);
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.welcome, relationship),
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      intent: nextButtonProps.intent,
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'step1-next-btn',
      onClick: () => {
        if (!isPreview) {
          logBI(10801);
        }

        if ((selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id) === NEW_BUSINESS_NAME_FLAG) {
          createOrSelectBusiness(NEW_BUSINESS_NAME_FLAG);
        }

        onDone();
      }
    }, nextButtonProps.text),
    testid: "welcome-step"
  }, /*#__PURE__*/React.createElement(TextBox, null, /*#__PURE__*/React.createElement(AgreementHeader, {
    relationship: relationship,
    companyName: (_selectedWorkspace$na = selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.name) !== null && _selectedWorkspace$na !== void 0 ? _selectedWorkspace$na : '',
    className: cn(styles.agreementHeader, {
      [styles.mobile]: isMobile
    }),
    isPreview: isPreview,
    refresh: refresh,
    supportContactEditing: true
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    showWhiteSpaces: true,
    breakWords: true,
    className: cn(styles.coverLetter, {
      [styles.mobile]: isMobile
    })
  }, replacePlaceholders(relationship.customNotificationText, (_relationship$buyer$f = relationship.buyer.firstName) !== null && _relationship$buyer$f !== void 0 ? _relationship$buyer$f : '', relationship.vendor.name))));
}